<div
  *ngFor="let goalForm of accountGoalsForms.controls; let index = index"
  class="u-marginBottom-16"
>
  <app-group-set-development-goal
    [group]="group"
    [user]="user"
    [goal]="getGoalForForm({ accountGoals, goalControl: goalForm }) || {}"
    [goalForm]="getFormGroup(goalForm)"
    [goalIndex]="index"
    (goalDeleted)="deleteAccountGoalForm($event)"
  ></app-group-set-development-goal>
</div>
<div class="u-textAlign-center u-marginTop-16">
  <button
    mat-stroked-button
    color="primary"
    (click)="addNewAccountGoal()"
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="center center"
    class="u-width-100"
  >
    <mat-icon color="primary" class="u-marginRight-8">add</mat-icon>
    <span i18n="@@groupAccountGoals.addCta">Add goal</span>
  </button>
</div>
